export const decedentQueryKeys = {
  all: ['decedent'],
  lists: ['decedent', 'lists'],
  list: ['decedent', 'list'],
  details: ['decedent', 'details'],
  detail: (decedentId) => ['decedent', 'detail', decedentId],
  taskLists: (decedentId) => ['decedent', 'task-list', decedentId],
  taskList: (decedentId, module) => ['decedent', 'task-list', decedentId, module],
};
